import { useMemo } from 'react';
import * as yup from 'yup';

const REQUIRED_ERROR = 'This field is required';
const EMAIL_ERROR = 'Wrong email format';

const useContactFormValidation = (): any =>
  useMemo(
    () =>
      yup.object().shape({
        name: yup.string().required(REQUIRED_ERROR),
        email: yup.string().email(EMAIL_ERROR).required(REQUIRED_ERROR),
        message: yup.string().required(REQUIRED_ERROR),
      }),
    []
  );

export default useContactFormValidation;
